'use client';

import { useEffect, useRef } from 'react';
import { useSearchParams } from 'next/navigation';
import useAuthStore from '@/store/useAuthStore';

type PublicLearnSeoCardsShellProps = {
  lessonTitle: string;
  children: React.ReactNode;
};

export default function PublicLearnSeoCardsShell({ lessonTitle, children }: PublicLearnSeoCardsShellProps) {
  const user = useAuthStore((state) => state.user);
  const searchParams = useSearchParams();
  const isPreviewMode = searchParams.get('preview') === '1';
  const rootRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const root = rootRef.current;
    const scrollContainer = root?.querySelector<HTMLElement>('[data-overview-scroll]');
    if (!scrollContainer) return;

    const handleWheel = (event: WheelEvent) => {
      event.preventDefault();

      if (scrollContainer.scrollHeight <= scrollContainer.clientHeight) {
        return;
      }

      scrollContainer.scrollTop += event.deltaY;
    };

    scrollContainer.addEventListener('wheel', handleWheel, { passive: false });
    return () => {
      scrollContainer.removeEventListener('wheel', handleWheel);
    };
  }, []);

  if (user && !isPreviewMode) {
    return null;
  }

  return (
    <div ref={rootRef} aria-label={`${lessonTitle} overview`}>
      {children}
    </div>
  );
}
